"use client";
import React, { useEffect, useState } from "react";
//import { fetchenquirydata } from '@packages/REST-API/rest-api';
import makeApiCall from "@packages/lib/server-actions/rest-api";
import API_URL from "@packages/lib/server-actions/api-urls";
// import { useRouter } from "next/navigation";
import {
  clickstreamForClicks,
  gaForCtaClicks,
  oldGAForCtaClicks,
  getProjectSpecificData,
  getCommonAPIHeaders,
  isPGS
} from "@packages/lib/utlils/commonFunction";
import { ClickstreamInterface } from "@packages/lib/utlils/clickstream";
import { ClickstreamConstants } from "@packages/shared-components/services/constants";
import ButtonLoader from "./ButtonLoader";
import { cleanUrl } from "@packages/lib/utlils/url-builder";
import { getCustomDomain } from "@packages/lib/utlils/common-function-server";
import { getCookie } from "@packages/lib/utlils/cookie-utils";
import OneClickProspectusModal from "@packages/shared-components/leadform/oneclick-prospectus-modal";
import { useIsLoggedInUser } from "@packages/hooks/LoggedInUser";
import ExitIntentForm from "@packages/shared-components/exit-intent-form/exit-intent-form";
import { fetchAuthSession } from "@aws-amplify/auth";
import { jwtDecode } from "jwt-decode";
import { v4 as uuidv4 } from "uuid";
import { getInteractionType } from "@packages/shared-components/leadform/field-registry";
import { LeadFormInteractionPayload } from "@packages/shared-components/leadform/types";
import { getCallbackUrl } from "@packages/lib/utlils/non-advert-pdf-utils";
import { triggerSigninToast } from "@packages/shared-components/common-utilities/toast/signin-toast";
import { logClickstreamEvent } from "@packages/lib/utlils/clickstream";
import emitter, { CustomEvents } from "@packages/lib/eventEmitter/eventEmitter";
import {
  CS_EVENT_TYPES,
  CS_ACTION_TYPE,
  CS_NETWORK_ID,
  CS_SYSTEM_NAME,
  CS_FUNCTIONALITY,
  CS_CTA_TITLES,
  CS_PAGE_NAMES,
  CS_PGS_NETWORK_ID,
} from "@packages/lib/utlils/clickstream-constants";

const DIRECT_SUBMIT_API_DOMAIN = process.env.NEXT_PUBLIC_BFF_API_DOMAIN || "";
const DIRECT_SUBMIT_SITE_CODE = process.env.NEXT_PUBLIC_SITE_CODE || "WU";
const INTERACTIONS_ENDPOINT = "/hewebsites/v1/leadProfile/interactions/submit";

const getDirectSubmitHeaders = (token?: string) => ({
  ...getCommonAPIHeaders(),
  siteCode: DIRECT_SUBMIT_SITE_CODE,
  Lp: "Y",
  "x-correlation-id": uuidv4(),
  ...(token
    ? { Authorization: token.startsWith("Bearer ") ? token : `Bearer ${token}` }
    : {}),
});

interface GetprospectusProps {
  enquiryProps: any;
  commonGAAttrs?: any;
  btnSize?: string;
  leafbtn?: any;
  btnName?: string;
  commonOldGAAttrs?: any;
}

const Getprospectus = ({
  enquiryProps,
  commonGAAttrs = {} as any,
  btnSize = "w-full",
  leafbtn,
  btnName,
  commonOldGAAttrs,
}: GetprospectusProps) => {
  const [url, setUrl] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showExitIntent, setShowExitIntent] = useState<boolean>(false);
  const [isLoggedInUser] = useIsLoggedInUser();

  const [showOneClickModal, setShowOneClickModal] = useState(false);
  const [oneClickProspectusType, setOneClickProspectusType] = useState<
    "digital" | "physical"
  >("digital");
  const [oneClickEnquiryResponse, setOneClickEnquiryResponse] =
    useState<any>(null);
  const [oneClickUserDetails, setOneClickUserDetails] = useState<any>(null);
  var csData: ClickstreamInterface = {} as ClickstreamInterface;
  csData.CTATitle = ClickstreamConstants.getProspectusCTA;
  csData.actionType = ClickstreamConstants.clickAction;
  csData.functionalityName =
    enquiryProps?.sponsoredListingFlag === "Y"
      ? ClickstreamConstants.sponsorListing
      : ClickstreamConstants.getProspectusCTA;
  useEffect(() => {
    if (url) {
      window.location.href = cleanUrl(url);
    }
  }, [url]);
  commonGAAttrs.click_text = csData.CTATitle;

  // Show exit-intent popup for guest users once per session (external URLs only)
  // Whatuni only — exit-intent flow is not enabled for PGS.
  const triggerExitIntent = () => {
    if (
      !isPGS() &&
      !isLoggedInUser &&
      !sessionStorage.getItem("exitIntentShown")
    ) {
      sessionStorage.setItem("exitIntentShown", "true");
      setShowExitIntent(true);
    }
  };

  const handleExternalProspectus = async (
    externalUrl: string,
    response: any,
  ) => {
    csData.eventType = ClickstreamConstants.prospectusExternalEvent;
    csData.externalUrl = externalUrl;
    enquiryProps.url = externalUrl;
    enquiryProps.revenueValue = response?.webformPrice;
    commonGAAttrs.click_text = csData.CTATitle;
    gaForCtaClicks(
      enquiryProps,
      "prospectus_external",
      commonGAAttrs,
      response.cpeFlag,
    );
    await clickstreamForClicks(enquiryProps, csData, commonGAAttrs, "");
    window.open(externalUrl, "_blank");
    triggerExitIntent();
  };

  const buildProspectusUrl = (response: any) => {
    const contextpath = isPGS() ? "pgs" : "degrees";
    const baseUrl = `/${contextpath}/prospectus${enquiryProps?.collegeName ? `/${enquiryProps?.collegeName}-prospectus` : ""}${enquiryProps?.collegeId ? `/${enquiryProps?.collegeId}` : ""}${enquiryProps?.courseId ? `/${enquiryProps?.courseId}` : "/0"}${enquiryProps?.selectedSubject ? `/${enquiryProps?.selectedSubject}` : "/0"}`;

    /*if (process.env.PROJECT === "PGS") {
      return `/pgs/pgs_interactive.get_request_prospectus_prc?${enquiryProps?.collegeId ? `z=${enquiryProps?.collegeId}` : ""}${response?.orderItemId ? `&p_order_item_id=${response?.orderItemId}` : ""}&pageName=${enquiryProps?.pageName}`;
    }*/

    const sponsorParam = `sponsoredOrderItemId=${enquiryProps?.sponsoredListingFlag === "Y" ? enquiryProps?.orderItemId || "" : ""}`;
    const subOrderId = enquiryProps?.subOrderItemId
      ? `n-${enquiryProps?.subOrderItemId}`
      : "n-";

    const pageNameMap: Record<string, string> = {
      browsemoneypageresults: "sr",
      uniprofile: "contenthub",
      coursesearchresult: enquiryProps?.pageName,
      coursedetails: enquiryProps?.pageName,
      contenthub: enquiryProps?.pageName,
    };

    const pageName =
      pageNameMap[enquiryProps?.pageName] || enquiryProps?.pageName;
    const additionalParams =
      enquiryProps?.pageName === "browsemoneypageresults"
        ? `&manualBoostingFlag=${enquiryProps?.manualBoostingFlag || "N"}`
        : "";
    const nonAdvertiserFlag = !enquiryProps?.subOrderItemId
      ? "&nonAdvertiserFlag=Y"
      : "";

    return `${baseUrl}/${subOrderId}/order-prospectus.html?${sponsorParam}&pageName=${pageName}${additionalParams}${nonAdvertiserFlag}`;
  };

  const handleGetProspectus = async () => {
    setIsLoading(true);
    try {
      const getProspectusPayload: any = {
        suborderItemId: enquiryProps?.subOrderItemId,
        orderItemId: enquiryProps?.orderItemId,
        collegeId: enquiryProps?.collegeId,
        courseId: enquiryProps?.courseId,
        affiliateId: getProjectSpecificData("affiliateId"),
        qualCode: enquiryProps?.qualCode,
      };
      commonGAAttrs.study_mode = enquiryProps?.studyMode;
      if (sessionStorage.getItem("veppleProviders")) {
        commonOldGAAttrs.data_label5 = "vepple_driven";
      }

      // If user is signed in, include Bearer token, Lp header, and purpose in payload
      const idToken =  isPGS() ? getCookie("pgsIdToken"): getCookie("wuIdToken");
      const headers: Record<string, string> = {
        "x-api-key": `${process.env.NEXT_PUBLIC_DOMSERVICE_X_API_KEY}`,
      };
      if (idToken) {
        headers["Authorization"] = `Bearer ${idToken}`;
        headers["Lp"] = "Y";
        getProspectusPayload.purpose = "PROSPECTUS_TYPE";
        getProspectusPayload.enquiryDetails = [
          {
            suborderItemId: enquiryProps?.subOrderItemId,
            institutionId: enquiryProps?.collegeId,
          },
        ];
      }

      const fetchresponse = await makeApiCall({
        url: `${process.env.NEXT_PUBLIC_DOMSERVICE_API_DOMAIN}/${API_URL?.getEnquiryDetails}`,
        method: "POST",
        queryParams: {},
        body: getProspectusPayload,
        headers,
      });
      const resData = fetchresponse?.prospectusDetails?.[0] || fetchresponse;

      // Direct submit flow: if user is signed in and both oneClickFlag and oneClickCheckboxFlag are "N",
      // submit directly without showing form or modal
      if (
        idToken &&
        fetchresponse?.oneClickFlag === "Y" &&
        fetchresponse?.oneClickCheckboxFlag === "Y"
      ) {
        try {
          const session = await fetchAuthSession({ forceRefresh: true });
          const freshIdToken = session?.tokens?.idToken?.toString();
          if (!freshIdToken) {
            setIsLoading(false);
            return;
          }

          const digitalFlag = resData?.digitalProspectus === "Y";
          const isPhysical = !digitalFlag;
          const userDetailsData = fetchresponse?.userDetails;
          const affiliateId =
            Number(getProjectSpecificData("affiliateId")) || null;
          const widgetId = Number(getCookie("widgetId")) || null;

          const directSubmitPayload: LeadFormInteractionPayload = {
            interactionType: getInteractionType(
              isPhysical ? "physicalprospectus" : "digitalprospectus",
            ),
            interactionId: null,
            collegeId: Number(enquiryProps?.collegeId) || 0,
            courseId: enquiryProps?.courseId
              ? Number(enquiryProps.courseId)
              : null,
            interactivityId: null,
            dateSent: null,
            affiliateId,
            emailContent: null,
            providerEmailId: null,
            subOrderItemId: enquiryProps?.subOrderItemId
              ? Number(enquiryProps.subOrderItemId)
              : null,
            profileId: null,
            widgetId,
            postEnquiryFlag: null,
            mobileFlag: null,
            appFlag: null,
            clientConsentFlag: null,
            clientConsentDate: null,
            orderItemId:
              resData?.orderItemId || enquiryProps?.orderItemId || null,
            ipAddress: null,
            odEventId: null,
            qualificationInterest: null,
            subjectInterest: null,
            enquiryTypeId: null,
            trackUserActionId: null,
            createdAt: null,
            updatedAt: null,
            city: userDetailsData?.town || null,
            town: userDetailsData?.town || null,
            postCode: userDetailsData?.postcode || null,
            addressLineOne: userDetailsData?.address1 || null,
            addressLineTwo: userDetailsData?.address2 || null,
            country: userDetailsData?.country,
            requestUrl:
              typeof window !== "undefined" ? window.location.href : null,
            referrerUrl:
              typeof window !== "undefined"
                ? document.referrer || getCallbackUrl() || ""
                : null,
            firstName: userDetailsData?.foreName || null,
            lastName: userDetailsData?.surname || null,
            userEmail: userDetailsData?.email || null,
            inTakeYear: userDetailsData?.yearOfEntry || null,
          };

          // Fallback: decode JWT for user fields if not available from userDetailsData
          const decoded: any = freshIdToken ? jwtDecode(freshIdToken) : null;
          if (!directSubmitPayload.firstName && decoded?.given_name) {
            directSubmitPayload.firstName = decoded.given_name;
          }
          if (!directSubmitPayload.lastName && decoded?.family_name) {
            directSubmitPayload.lastName = decoded.family_name;
          }
          if (!directSubmitPayload.userEmail && decoded?.email) {
            directSubmitPayload.userEmail = decoded.email.toLowerCase();
          }

          const response = await fetch(
            `${DIRECT_SUBMIT_API_DOMAIN}${INTERACTIONS_ENDPOINT}`,
            {
              method: "POST",
              headers: getDirectSubmitHeaders(freshIdToken),
              body: JSON.stringify(directSubmitPayload),
            },
          );

          const responseData = await response.json().catch(() => null);

          if (!response.ok || responseData?.status === 409) {
            if (response.status === 409 || responseData?.status === 409) {
              triggerSigninToast(
                "You've already requested a prospectus for this university in the last 24 hours.",
              );
              emitter.emit(CustomEvents.PostAuthRefresh);
            }
            setIsLoading(false);
            return;
          }

          // Clickstream: fire ProspectusRequested / DigitalProspectusRequested
          logClickstreamEvent({
            eventType: isPhysical
              ? CS_EVENT_TYPES.PROSPECTUS_REQUESTED
              : CS_EVENT_TYPES.DIGITAL_PROSPECTUS_REQUESTED,
            pageName: CS_PAGE_NAMES.ENQUIRY_PAGE,
            actionType: CS_ACTION_TYPE,
            CTATitle: CS_CTA_TITLES.GET_PROSPECTUS,
            isAdvertiser: enquiryProps?.subOrderItemId ? "Y" : "N",
            idpcInstitutionId: enquiryProps?.collegeId || "",
            subOrderItemId: enquiryProps?.subOrderItemId || "",
            sourceOrderItemIdForEnq: enquiryProps?.sponsoredOrderItemId || "",
            networkId: isPGS() ? CS_PGS_NETWORK_ID : CS_NETWORK_ID,
            idpcCourseId: enquiryProps?.courseId || "",
            systemname: CS_SYSTEM_NAME,
            surveyConsent: "N",
            newsletterConsent: "N",
            solusConsent: "N",
            ...(isPhysical
              ? {}
              : {
                  functionalityName: CS_FUNCTIONALITY.DOWNLOAD_PROSPECTUS,
                  downloadFlag: "Yes",
                }),
          });

          triggerSigninToast("Your prospectus request has been sent");
          emitter.emit(CustomEvents.PostAuthRefresh);
          setIsLoading(false);
          return;
        } catch (error) {
          console.error("Direct submit failed:", error);
          setIsLoading(false);
          return;
        }
      }
      // One-click flow: if user is signed in and isOneClick === "Y", open popup
      if (idToken && fetchresponse?.oneClickFlag === "Y") {
        const digitalFlag = resData?.digitalProspectus === "Y";
        setOneClickProspectusType(digitalFlag ? "digital" : "physical");
        setOneClickEnquiryResponse(resData);
        setOneClickUserDetails(fetchresponse?.userDetails || null);
        setShowOneClickModal(true);
        setIsLoading(false);
        return;
      }
      if (resData?.stdGetProspectusUrl) {
        csData.eventType = ClickstreamConstants.prospectusExternalEvent;
        csData.externalUrl = resData.stdGetProspectusUrl;
        enquiryProps.revenueValue = resData?.webformPrice;
        enquiryProps.url = resData.stdGetProspectusUrl;
        oldGAForCtaClicks(
          enquiryProps,
          "Get prospectus",
          enquiryProps.url,
          enquiryProps.event,
          commonOldGAAttrs,
          resData?.cpeFlag,
          resData?.digitalProspectus,
        );
        await clickstreamForClicks(enquiryProps, csData, commonGAAttrs, "");
        window.open(resData.stdGetProspectusUrl, "_blank");
        triggerExitIntent();
        setIsLoading(false);
      } else if (resData?.requestProspectusWebform) {
        csData.eventType = ClickstreamConstants.prospectusExternalEvent;
        csData.externalUrl = resData.requestProspectusWebform;
        enquiryProps.revenueValue = resData?.webformPrice;
        enquiryProps.url = resData.requestProspectusWebform;
        gaForCtaClicks(enquiryProps, "prospectus_external", commonGAAttrs);
        await clickstreamForClicks(enquiryProps, csData, commonGAAttrs, "");
        window.open(resData.requestProspectusWebform, "_blank");
        triggerExitIntent();
        setIsLoading(false);
      } else if (
        resData?.requestProspectusEmail ||
        resData?.digitalProspectus?.toLowerCase() === "y"
      ) {
        const digitalFlag = resData.digitalProspectus === "Y";
        const prospectusUrl = buildProspectusUrl(resData);
        enquiryProps.revenueValue = resData?.emailPrice;
        enquiryProps.url = getCustomDomain() + prospectusUrl;
        csData.eventType = digitalFlag
          ? ClickstreamConstants.digitalProspectusEvent
          : ClickstreamConstants.physicalProspetcusEvent;
        csData.functionalityName = digitalFlag
          ? "DOWNLOAD PROSPECTUS"
          : "Get prospectus";
        gaForCtaClicks(
          enquiryProps,
          "prospectus_request",
          commonGAAttrs,
          resData.cpeFlag,
          resData.digitalProspectus,
        );
        await clickstreamForClicks(
          enquiryProps,
          csData,
          commonGAAttrs,
          resData?.digitalProspectus,
        );
        setUrl(prospectusUrl);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching enquiry data:", error);
      setIsLoading(false);
    }
  };

  function getSponsorOrderItemId() {
    return `sponsoredOrderItemId=${enquiryProps?.sponsoredListingFlag === "Y" ? enquiryProps?.orderItemId || "" : ""}`;
  }

  return (
    <>
      {leafbtn ? (
        <button
          type="button"
          onClick={handleGetProspectus}
          className="flex gap-[6px] items-center btn btn-primary rtfcustom-link hover:no-underline px-[20px] py-[10px] w-fit !no-underline"
        >
          {ClickstreamConstants.getProspectusCTA}
          {isLoading ? (
            <svg
              className="animate-spin h-[16px] w-[16px]"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
              />
            </svg>
          ) : (
            <svg
              width="16"
              height="14"
              viewBox="0 0 16 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.55556 1.55554L15 6.99999M15 6.99999L9.55555 12.4444M15 6.99999L1 6.99999"
                stroke="#fff"
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </button>
      ) : (
        <button
          id="gp-btn"
          type="button"
          className={`btn btn-tertiary flex justify-center items-center ${btnSize}`}
          onClick={handleGetProspectus}
        >
          <ButtonLoader isLoading={isLoading}>
            {btnName || ClickstreamConstants.getProspectusCTA}
          </ButtonLoader>
        </button>
      )}

      {/* One-Click Prospectus Modal */}
      <OneClickProspectusModal
        isOpen={showOneClickModal}
        onClose={() => setShowOneClickModal(false)}
        enquiryProps={enquiryProps}
        prospectusType={oneClickProspectusType}
        enquiryResponse={oneClickEnquiryResponse}
        userDetails={oneClickUserDetails}
      />

      {showExitIntent && (
        <ExitIntentForm
          sourceClickText="get_prospectus"
          onClose={() => setShowExitIntent(false)}
          onSubmit={() => {}}
        />
      )}
    </>
  );
};

export default Getprospectus;
